module.exports = "<list-packing-relabel></list-packing-relabel>\n"